import { createClass as _createClass, classCallCheck as _classCallCheck } from './_virtual/_rollupPluginBabelHelpers.js';
import moment$1 from 'moment';

var CookieService = /*#__PURE__*/function () {
  function CookieService() {
    _classCallCheck(this, CookieService);
  }

  _createClass(CookieService, [{
    key: "set",
    value: function set(name, value) {
      var minutesToExpire = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
      var expirationDate = moment$1().add(minutesToExpire, "m").toDate();
      document.cookie = name + "=" + escape(value) + "; expires=" + expirationDate.toUTCString() + "; path=" + path;
    }
  }, {
    key: "get",
    value: function get(name) {
      var key,
          value,
          cookies = document.cookie.split(";");

      for (var i = 0, length = cookies.length; i < length; i++) {
        key = cookies[i].substr(0, cookies[i].indexOf("=")).replace(/^\s+|\s+$/g, "");
        value = cookies[i].substr(cookies[i].indexOf("=") + 1);

        if (key === name) {
          return decodeURI(value);
        }
      }
    }
  }]);

  return CookieService;
}();

var cookie = new CookieService();

export default cookie;
//# sourceMappingURL=cookie.js.map
